import { Paragraph } from "@sb1/ffe-core-react";
import { Spinner } from "@sb1/ffe-spinner-react";
import type { FC } from "react";
import { Grid, GridCol, GridRow } from "~/shared/components/ffe-grid";

interface Props {
	className?: string;
	text?: string;
}

const StorSpinner: FC<Props> = ({ text, ...rest }) => (
	<Grid>
		<GridRow className="ppm-grid__row--padding-top">
			<GridCol center={true}>
				<Spinner large={true} style={{ textAlign: "center" }} {...rest} loadingText={<Paragraph>{text ?? "Laster..."}</Paragraph>} />
			</GridCol>
		</GridRow>
	</Grid>
);
export default StorSpinner;
